var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ApplicationWrapper",
    {
      attrs: {
        headerBackTooltip: _vm.$t("overview.details_header_backToHallDetails"),
        headerImage: _vm.hall.Image,
        headerTitle: _vm.hall.Title,
      },
      on: { onButtonBackClick: _vm.handleButtonBackClick },
    },
    [
      _c(
        "template",
        { slot: "details" },
        [
          _c(
            "v-list",
            {
              staticClass: "nomargin-firstchild nomargin-lastchild",
              attrs: { "two-line": "" },
            },
            [
              _c(
                "Detail",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("DatePicker", {
                        staticStyle: { "z-index": "1000" },
                        attrs: {
                          label: _vm.$t("common.label_date"),
                          prependIcon: "mdi-calendar",
                          textFieldIsReadonly: true,
                        },
                        model: {
                          value: _vm.inputDate,
                          callback: function ($$v) {
                            _vm.inputDate = $$v
                          },
                          expression: "inputDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "Detail",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "flex-column flex-sm-row",
                          staticStyle: { gap: "16px" },
                          attrs: { "no-gutters": "", align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            [
                              _c("TimePicker", {
                                attrs: {
                                  label: _vm.$t("common.label_from"),
                                  prependIcon: "mdi-clock-start",
                                  min: _vm.timeMin,
                                  max: _vm.timeMax,
                                  textFieldIsReadonly: "",
                                  disabled: _vm.bookingData.wholeDay,
                                  step: _vm.durationStep,
                                },
                                model: {
                                  value: _vm.inputTimeFrom,
                                  callback: function ($$v) {
                                    _vm.inputTimeFrom = $$v
                                  },
                                  expression: "inputTimeFrom",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("TimePicker", {
                                attrs: {
                                  label: _vm.$t("common.label_to"),
                                  prependIcon: "mdi-clock-end",
                                  min: _vm.timeMin,
                                  max: _vm.timeMax,
                                  textFieldIsReadonly: "",
                                  disabled: _vm.bookingData.wholeDay,
                                  step: _vm.durationStep,
                                },
                                model: {
                                  value: _vm.inputTimeTo,
                                  callback: function ($$v) {
                                    _vm.inputTimeTo = $$v
                                  },
                                  expression: "inputTimeTo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  value: _vm.bookingData.duration,
                                  label: _vm.$t("common.label_duration"),
                                  min:
                                    _vm.hall.details.MinimalBookingDuration == 0
                                      ? _vm.hall.details.BookingBlock
                                      : _vm.hall.details.MinimalBookingDuration,
                                  disabled: _vm.bookingData.wholeDay,
                                  suffix: _vm.$t("common.label_minutes"),
                                  step: _vm.durationStep,
                                  type: "number",
                                  rules: _vm.commonRules,
                                  "prepend-icon": "mdi-clock-outline",
                                },
                                on: { input: _vm.handleDurationInput },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        {
                          attrs: {
                            "no-gutters": "",
                            justify: "start",
                            align: "center",
                          },
                        },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _vm.errors.length > 0
                                ? _c(
                                    "Detail",
                                    {
                                      attrs: {
                                        containerNoPadding: true,
                                        standalone: true,
                                      },
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "header" },
                                        [
                                          _c("v-list-item-title", [
                                            _c("div", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.errors.length > 1
                                                    ? _vm.$t(
                                                        "common.label_errorsOccured"
                                                      )
                                                    : _vm.$t(
                                                        "common.label_errorOccured"
                                                      )
                                                ),
                                              },
                                            }),
                                          ]),
                                          _vm._l(_vm.errors, function (error) {
                                            return _c(
                                              "v-list-item-subtitle",
                                              {
                                                key: "hallMeetingError" + error,
                                                staticClass: "red--text",
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(error) + " "
                                                ),
                                              ]
                                            )
                                          }),
                                        ],
                                        2
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.$t("common.label_meetingWholeDay"),
                                },
                                model: {
                                  value: _vm.inputWholeDay,
                                  callback: function ($$v) {
                                    _vm.inputWholeDay = $$v
                                  },
                                  expression: "inputWholeDay",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm.hall.meetings && _vm.hall.meetings.length > 0
                ? _c(
                    "Detail",
                    {
                      attrs: {
                        expansionStayOpen: true,
                        expandable: true,
                        prependIcon: "",
                        title: _vm.$t("common.label_meetingQueryHasResults", [
                          _vm.hall.meetings.length,
                        ]),
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "expansion-content" },
                        [
                          _c(
                            "v-list",
                            {
                              staticStyle: {
                                "max-height": "340px",
                                "overflow-y": "auto",
                                width: "100%",
                              },
                              attrs: { dense: "" },
                            },
                            [
                              _c(
                                "v-list-item-group",
                                {
                                  attrs: { color: "primary" },
                                  model: {
                                    value: _vm.listSelection,
                                    callback: function ($$v) {
                                      _vm.listSelection = $$v
                                    },
                                    expression: "listSelection",
                                  },
                                },
                                _vm._l(
                                  _vm.hall.meetings,
                                  function (meeting, index) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: "hallMeeting_" + index,
                                        attrs: { "two-line": "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleMeetingSelection(
                                              meeting
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    meeting.From +
                                                      _vm.spacing +
                                                      "—" +
                                                      _vm.spacing +
                                                      meeting.To
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$d(
                                                      new Date(meeting.Date),
                                                      "longDate"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            Object.keys(meeting).includes(
                                              "rent"
                                            )
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$n(
                                                          meeting.rent,
                                                          "currency",
                                                          "de-DE"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _c("Detail", {
                    attrs: {
                      title: _vm.$t("payment.noMeetings"),
                      subTitle: _vm.$t("payment.userMayAdjustSettings"),
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "actionbuttons" },
        [
          _c(
            "v-btn",
            {
              staticClass: "ma-4",
              attrs: {
                disabled: _vm.listSelection === undefined,
                color: "primary",
              },
              on: { click: _vm.handleBookingClick },
            },
            [
              _c("div", {
                domProps: { textContent: _vm._s(_vm.meetingButtonText) },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }